const PHONE_REGEX = /^(\s*)?(\+)?([- _():=+]?\d[- _():=+]?){10,14}(\s*)?$/

const isPhoneNumberValid = phoneNumber => {
  return PHONE_REGEX.test(phoneNumber.toLocaleLowerCase())
}

export default isPhoneNumberValid
